/* eslint-disable react-hooks/rules-of-hooks */
// 3rd party libraries
import Prismic from '@prismicio/client'
import { RichText, RichTextBlock } from 'prismic-reactjs'
import SliceZone from 'next-slicezone'
import { useGetStaticProps } from 'next-slicezone/hooks'
// Services&Helper functions
import resolver from '../sm-resolver.js'
// Styles
import s from '../styles/pages/QuestionsAndAnswers.module.scss'
// Components
import { Container } from '../components/core/container/Container'
import { Section } from '../components/core/section/Section'
import { Text } from '../components/core/text/Text'
import Meta from '../components/meta/Meta'

// Fetch content from prismic
export const getStaticProps = useGetStaticProps({
    // @ts-ignore
    client: Prismic.client('https://minningar.cdn.prismic.io/api/v2'),
    queryType: 'single',
    type: 'questions-and-answers',
})

type Props = JSX.IntrinsicAttributes & {
    slices: any
    data: {
        titill: RichTextBlock[]
        description: RichTextBlock[]
        buttonlink: string
        sharetitle?: string
        sharedescription?: string
        shareimage?
        [keys: string]: any
    }
}

const Page = (props: Props) => {
    return (
        <>
            <Section>
                <Meta
                    title="Minningar - Spurt og svarað"
                    seoTitle={`Minningar - ${
                        props.data.sharetitle ||
                        RichText.asText(props.data.titill)
                    }`}
                    description={`${props.data.sharedescription || ''}`}
                    url="https://minningar.is/questions-and-answers/"
                    type="website"
                    image={props.data.shareimage?.url}
                />
                <Container className={s.header}>
                    <Text variant="h1" className={s.header__item}>
                        {RichText.asText(props.data.titill)}
                    </Text>
                </Container>
            </Section>
            <SliceZone slices={props.slices} resolver={resolver} />
        </>
    )
}

export default Page
